import type { Lang } from "@/i18n/languages";

const FALLBACK: Lang = "bg";

export function getDefaultLangFromHostname(hostname: string): Lang {
  const h = (hostname || "").toLowerCase();

  // Local/dev
  if (h.includes("localhost") || h.startsWith("127.0.")) return FALLBACK;

  if (h.endsWith(".bg")) return "bg";
  if (h.endsWith(".eu")) return "en";
  if (h.endsWith(".de")) return "de";
  if (h.endsWith(".gr")) return "gr";

  // Default: Bulgarian
  return FALLBACK;
}
